import Vue from "vue";

import DigitalPurchasesList from "./DigitalPurchasesList.vue";

export function load() {
    const selector = "digital-purchases-list";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(DigitalPurchasesList, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
